module.exports = __webpack_public_path__ + "img/flysafair_logo.1ac45591.svg";